var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column","width":"228px","height":"60px"}},[_c('div',{staticStyle:{"height":"60px","width":"228px"},attrs:{"id":_vm.echartId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }